// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"dcacfd6d","88":"e6f82b22","114":"408246ab","144":"d54b6980","200":"94062d6b","256":"2774304e","348":"ae6497c7","396":"59ab2e9f","434":"39eca074","488":"945558da","624":"4c7a4e96","650":"f18d5a3f","752":"be2352f6"}[chunkId] + ".chunk.js";
};